import React, { useCallback, useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import { useAppDispatch, useAppSelector } from "../../../../../store/hooks";

import {
  useCreateNewConversationType,
  useDeleteConversationType,
  useGenerativePersona,
  useUpdateConversationType,
} from "../../../../../store/Apis/ConversationTypeApi";
import { setFileError, setSelectedPersona } from "../../../../../store/one-query/chatsSlice";
import { FinishMark, MessageType, PersonaItemData } from "../../../../../Helper";
import { ErrorIcon } from "../../../../../Custom-imeges/ErrorIcon";
import GerenerateIcon from "../../../../../Custom-imeges/GerenerateIcon";
import SignalRService from "../../../../one-query/services/SignalRService";
import CircularProgress from "@mui/material/CircularProgress";

interface PersonaProps {
  show: boolean;
  handleClose: () => void;
  personaModalType: string;
  personaItemDelete: PersonaItemData | undefined;
  updateCurrentPersona: any;
  setSelectedPersonaItem: (persona:string) => void;
}
interface ConversationTypeRecord {
  id: string;
  title: string;
  description: string;
  objective: string;
  createdAt: string;
}
interface PersonaDataTypes {
  title: string;
  description: string;
  objective: string;
}
const PersonaModal: React.FC<PersonaProps> = ({
  show,
  handleClose,
  personaModalType,
  personaItemDelete,
  updateCurrentPersona,
  setSelectedPersonaItem,
}) => {
  const [editPersona, setEditPersona] = useState<ConversationTypeRecord>({
    id: "",
    title: "",
    description: "",
    objective: "",
    createdAt: "",
  });
  const [isFocused, setIsFocused] = useState(false);

  const [formErrors, setFormErrors] = useState({
    nameError: false,
    desErrors: false,
    errorMsg:""
  });

  const [editFormErrors, setEditFormErrors] = useState({
    nameError: false,
    desErrors: false,
    errorMsg:""
  });

  const dispatch = useAppDispatch();
  const [personaData, setPersonaData] = useState<PersonaDataTypes>({
    title: "",
    description: "",
    objective: "",
  });
  const [btnDeleteDisable, setBtnDeleteDisable] = useState(true);
  const [wordDeleteMatch, setWordDeleteMatch] = useState("");
  const deleteConversationType = useDeleteConversationType();
  const generateDescAndObjPersona = useGenerativePersona();
  const {createNewConversationMutate, createSuccess, UpdateToggleCreation } = useCreateNewConversationType();
  const {updateConversationTypeMutate, updateSuccess, updateToggle } = useUpdateConversationType();
  const [showMssError,setShowMsgError] = useState(false);
  const [generateWordValue,setGenerateWordValue]=useState<string>("Generate description")
  const currentPersona = useAppSelector(
    (state) => state.ChatsState.selectedPersona
  );
  const [isFinished, setIsFinished] = useState<boolean>(true);
  const { title, description, objective } = personaData;
  useEffect(() => {
    if (updateCurrentPersona) {
      setEditPersona(updateCurrentPersona);
    }
  }, [updateCurrentPersona]);

  useEffect(() => {
    const hasNumbers = /\d/;

    if (editPersona.title.trim() === "") {
      setEditFormErrors({ nameError: true, desErrors: false, errorMsg: "Please enter persona name" });
    } else if (hasNumbers.test(editPersona.title)) {
      setEditFormErrors({ nameError: true, desErrors: false, errorMsg: "Numbers aren’t allowed in the title. Please use letters only." });
    } else if (editPersona.description.trim() === "" || editPersona.objective.trim() === "") {
      setEditFormErrors({ nameError: false, desErrors: true, errorMsg: "Description and objective cannot be empty" });
    } else if (hasNumbers.test(editPersona.description)) {
      setEditFormErrors({ nameError: false, desErrors: true, errorMsg: "Numbers aren’t allowed in the description. Please use letters only." });
    } else if (hasNumbers.test(editPersona.objective)) {
      setEditFormErrors({ nameError: false, desErrors: true, errorMsg: "Numbers aren’t allowed in the objective. Please use letters only." });
    } else {
      setEditFormErrors({ nameError: false, desErrors: false, errorMsg: "" });
    }
}, [editPersona]);

  useEffect(() => {
    const hasNumbers = /\d/;

    if (title.trim() === "") {
      setFormErrors({ nameError: true, desErrors: false, errorMsg: "Please enter persona name" });
    } else if (hasNumbers.test(title)) {
      setFormErrors({ nameError: true, desErrors: false, errorMsg: "Numbers aren’t allowed in the title. Please use letters only." });
    } else if (description.trim() === "" || objective.trim() === "") {
      setFormErrors({ nameError: false, desErrors: true, errorMsg: "Description and objective cannot be empty" });
    } else if (hasNumbers.test(description)) {
      setFormErrors({ nameError: false, desErrors: true, errorMsg: "Numbers aren’t allowed in the description. Please use letters only." });
    } else if (hasNumbers.test(objective)) {
      setFormErrors({ nameError: false, desErrors: true, errorMsg: "Numbers aren’t allowed in the objective. Please use letters only." });
    } else {
      setFormErrors({ nameError: false, desErrors: false, errorMsg: "" });
    }
}, [personaData]);

  const handleCloseAddPersona = () => {
    handleClose();
    setPersonaData({ title: "", description: "", objective: "" });
    setFormErrors({ nameError: false, desErrors: false, errorMsg: "" });
    setTimeout(() => {
      setGenerateWordValue("Generate description");
    }, 1000);
  };

  const CreatePersona = (e: any) => {
    setPersonaData((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value,
    }));
  };

const addNewPersona = () => {
  if (title === "") {
    setFormErrors({ nameError: true, desErrors: false, errorMsg: "Please enter persona name" });
  } else if (description === "") {
    setFormErrors({ nameError: false, desErrors: true, errorMsg: "Description cannot be empty" });
  } else if (objective === "") {
    setFormErrors({ nameError: false, desErrors: true, errorMsg: "Objective cannot be empty" });
  } else if (/\d/.test(title) || /\d/.test(description) || /\d/.test(objective)) {
    setFormErrors({ nameError: true, desErrors: true, errorMsg: "Numbers aren’t allowed in the title, description, or objective. Please use letters only." });
  } else {
    let newPersona = {
      title: title,
      id: null,
      description: description,
      objective: objective,
      createdAt: "",
      allowAnonymous: false,
    };
    createNewConversationMutate(newPersona);
    UpdateToggleCreation(false);
    // handleCloseAddPersona();
  }
};

  const handleCancel = () => {
    handleClose();
    setWordDeleteMatch("");
    setShowMsgError(false);
  };
  const handleDeleteItemWithId = () => {
    if (wordDeleteMatch.toLowerCase() === "delete") {
      setBtnDeleteDisable(false);
      if (personaItemDelete) deleteConversationType(personaItemDelete.id);
      setWordDeleteMatch("");
      handleCancel();
    setBtnDeleteDisable(false);
    }else{
      setShowMsgError(true)
    }
    setBtnDeleteDisable(true);
  };

  const handleDeleteItemWithIdUsingEnterKey = (
    e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    if (e.key === "Enter") handleDeleteItemWithId();
  };

  const handleChangeUpdatePersona = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    if (editPersona) {
      setEditPersona({
        ...editPersona,
        [e.target.name]: e.target.value,
      });
    }
  };

  const UpdateSpecificPersona = () => {
    if (editPersona) {
      updateConversationTypeMutate(editPersona);
      updateToggle(false);
      if(currentPersona.id === editPersona.id){
        setSelectedPersonaItem(editPersona.title)
        dispatch(setSelectedPersona(editPersona));
      }
    }
  };

  useEffect(()=> {
    if(updateSuccess || createSuccess){
      handleClose();
      setTimeout(() => {
        setPersonaData({ title: "", description: "", objective: "" });
        setGenerateWordValue("Generate description");
      }, 1000);
    }
  },[updateSuccess , createSuccess])
  const handleGeneratedescAndObjPersona =async () => {
    const connectionId = await SignalRService.getInstance().getConnectionId();
    if (connectionId && personaData.title) {
      setIsFinished(false)
      generateDescAndObjPersona({
        personaTitle: personaData.title,
        connectionId: connectionId,
      });
    }
    if (generateWordValue === "Re-generate") {
        setPersonaData((prevData) => ({
          ...prevData,
          description: "",
          objective: "",
        }));
    }
  };
  useEffect(() => {
    if (isFinished&&personaData.description.length>0 &&personaData.objective.length>0) {
      setGenerateWordValue("Re-generate description");
    }
  }, [isFinished]);
  const handleModelMessage = useCallback(
    (
      modelName: string,
      modelVersion: string,
      message: string,
      tag: string,
      conversationId: string,
      messageId: string,
      messageType: number
    ) => {
      if (
        messageType === MessageType.GeneratePersonaDescription &&
        message !== FinishMark
      ) {
        setPersonaData((prev) => ({
          ...prev,
          description: prev.description + message,
        }));
        setIsFinished(false);
      } else if (
        messageType === MessageType.GeneratePersonaObjective &&
        message !== FinishMark
      ) {
        setPersonaData((prev) => ({
          ...prev,
          objective: prev.objective + message,
        }));
        setIsFinished(false);
      } else if (
        messageType === MessageType.GeneratePersonaObjective &&
        message === FinishMark
      ) {
        setIsFinished(true);
      }
    },
    []
  );
  const setupSignalRConnection = useCallback(() => {
    const connection = SignalRService.getInstance().connection;
    connection.on("SendModelMessage", handleModelMessage);
    return () => {
      connection.off("SendModelMessage", handleModelMessage);
    };
  }, [handleModelMessage]);

  useEffect(() => {
    const cleanup = setupSignalRConnection();
    return () => {
      cleanup();
    };
  }, [setupSignalRConnection]);

  // if user delete persona using id
  return personaModalType === "Delete" ? (
    <Modal
      className="personaModalDelete"
      show={show}
      onHide={handleCloseAddPersona}
      backdrop="static"
      centered
    >
      <Modal.Header>
        <Modal.Title>
          <p className="mb-0" style={{ fontSize: "14px" }}>
            Delete persona
          </p>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="personaBodyDelete px-0">
        <div className="containerFormDelete pb-1 px-4">
          <p className="deleteConfirmMsg w-100 mt-5 mb-2 text-start">
            You will not able to access "{personaItemDelete?.title}" again.
          </p>
          <div className="w-100">
            <Form.Control
              className="mt-3 mb-1 text-start"
              id="inputPersonaDelete"
              placeholder="Type 'delete' in the box to confirm."
              value={wordDeleteMatch}
              onKeyDown={(e) => handleDeleteItemWithIdUsingEnterKey(e)}
              onChange={(e) => setWordDeleteMatch(e.target.value)}
            />
             {showMssError && 
              <div className="match-error-msg">
                <ErrorIcon/>
                <span>Incorrect word.</span>
              </div>}
          </div>
        </div>
        <div className="line popup"></div>
        <div className="containerButtons w-100 d-flex align-items-center justify-content-end px-4">
          <button className="CancelDeletePersonaBtn me-3" onClick={handleCancel}>
            Cancel
          </button>
          <button
            className={`createPersonaBtn ${
              btnDeleteDisable ? "disableBtn" : "enableBtn"
            }`}
            onClick={handleDeleteItemWithId}
            disabled={!btnDeleteDisable}
          >
            Delete
          </button>
        </div>
      </Modal.Body>
    </Modal>
  ) : // if user create new persona
  personaModalType === "Create" ? (
    <Modal
      className="personaModal"
      show={show}
      size="lg"
      onHide={handleCloseAddPersona}
      backdrop="static"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <p className="mb-0" 
          style={{
            color:"var(--A-color34)",
          }}>
            Create a new persona
          </p>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <label className="personDesLabel" htmlFor="personaName">
          Name
        </label>
        <div
          className={`inputPersonaName w-100 ${
            formErrors.nameError && "personaError"
          }`}
        >
          <Form.Control
            id="personaName"
            placeholder="Enter persona name"
            className={`${
              formErrors.nameError  ?"missingInput":"not-error"
            }`}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            name="title"
            value={personaData.title}
            onChange={(e) => {
              CreatePersona(e);
            }}
          />
          {isFocused && !formErrors.nameError ? (
            <p className="inputMsg">
              Users will be able to select this Persona based on this name.
            </p>
          ) : (
            ""
          )}
          {formErrors.nameError && (
            <div className="d-flex align-items-center gap-1 mt-1">
              <img className="icn-error" />
              <p className="errorMsg mb-0">{formErrors.errorMsg}</p>
            </div>
          )}
        </div>
        <div className="d-flex justify-content-between align-items-center mt-2 mb-2">
          <label className="personDesLabel" htmlFor="personaDes">
            Description
          </label>
          <button
            className={`generate-btn ${
              !isFinished || formErrors.nameError ? "disabled" : "notDisabled"
            }`}
            disabled={!isFinished&&!!formErrors.nameError}
            onClick={isFinished && !formErrors.nameError ? handleGeneratedescAndObjPersona : undefined}
          >
            {!isFinished ? (
              <CircularProgress size={18} />
            ) : (
              <GerenerateIcon />
            )}
            {generateWordValue}
          </button>
        </div>
        <div className="desContainer">
          <div
            className={"inputPersonaDescription d-flex flex-column  w-100 "}
          >
            <Form.Control
              id="personaDes"
              className={`${
              formErrors.desErrors  ?"missingInput":"not-error"
            }`}
              placeholder="You are an description for a/an ..."
              value={personaData.description}
              name="description"
              onChange={(e) => CreatePersona(e)}
            />
            <textarea
              className={`${
              formErrors.desErrors ?"missingInput":"not-error"
            }`}
              placeholder="Your objective is to..."
              value={personaData.objective}
              name="objective"
              onChange={(e) => CreatePersona(e)}
            />
          </div>
          {formErrors.desErrors && (
            <div className="d-flex align-items-center gap-1 mt-1">
              <img className="icn-error" />
              <p className="errorMsg mb-0">
                {formErrors.errorMsg}
              </p>
            </div>
          )}
        </div>
        <div className="w-100 d-flex align-items-center justify-content-end mt-4">
        <button
            className="CancelDeletePersonaBtn cancelCreation me-3"
            onClick={handleCloseAddPersona}
          >
            Cancel
          </button>
          <button disabled={formErrors.nameError || formErrors.desErrors}
            className={`createPersonaBtn ${formErrors.nameError || formErrors.desErrors ? " disabled opacity-50" : ''}`}
            style={{cursor:(formErrors.nameError || formErrors.desErrors )?"no-drop":"pointer"}}
            onClick={addNewPersona}>
            Create
          </button>
        </div>
      </Modal.Body>
    </Modal>
  ) : (
    // if user update persona using id
    editPersona && (
      <Modal
        className="personaModal"
        show={show}
        size="lg"
        onHide={handleCloseAddPersona}
        backdrop="static"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <p className="mb-0" style={{color: "var(--A-color34)"}}>Edit persona</p>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label className="personDesLabel" htmlFor="personaName">
            Name
          </label>
          <div
            className={`inputPersonaName w-100 ${
              editFormErrors.nameError && "personaError"
            }`}
          >
            <Form.Control
              id="personaName"
              className={`${
              editFormErrors.nameError ? "missingInput":"not-error"
            }`}
              placeholder="Enter persona name"
              onFocus={() => setIsFocused(true)}
              onBlur={() => setIsFocused(false)}
              name="title"
              value={editPersona.title}
              onChange={(e) => handleChangeUpdatePersona(e)}
            />
             {editFormErrors.nameError && (
            <div className="d-flex align-items-center gap-1 mt-1">
              <img className="icn-error" />
              <p className="errorMsg mb-0">{editFormErrors.errorMsg}</p>
            </div>
            )}
          </div>
          <label className="personDesLabel" htmlFor="personaDes">
            Description
          </label>
          <div className="desContainer">
            <div
              className={"inputPersonaDescription d-flex flex-column  w-100"}
            >
              <Form.Control
               className={`${
                editFormErrors.desErrors ? "missingInput":"not-error"
              }`}
                id="personaDes"
                placeholder="You are an description for a/an ..."
                value={editPersona.description}
                name="description"
                onChange={(e) => handleChangeUpdatePersona(e)}
              />
              <textarea
                className={`w-100 ${
                editFormErrors.desErrors ? "missingInput":"not-error"
              }`}
                placeholder="Your objective is to..."
                value={editPersona.objective}
                name="objective"
                onChange={(e) => handleChangeUpdatePersona(e)}
              />
            </div>
           {editFormErrors.desErrors && (
            <div className="d-flex align-items-center gap-1 mt-1">
              <img className="icn-error" />
              <p className="errorMsg mb-0">
                {editFormErrors.errorMsg}
              </p>
            </div>
          )}
          </div>
          <div className="w-100 d-flex align-items-center justify-content-end mt-4">
              <button disabled={editFormErrors.nameError || editFormErrors.desErrors}
                className={`createPersonaBtn ${editFormErrors.nameError || editFormErrors.desErrors ? "disabled opacity-50" : ''}`} 
                 style={{cursor:(editFormErrors.nameError || editFormErrors.desErrors)?"no-drop":"pointer"}}
                onClick={UpdateSpecificPersona}>
                Save changes
              </button>
          </div>
        </Modal.Body>
      </Modal>
    )
  );
};

export default PersonaModal;
